import { useEffect } from 'react';
import { apiService } from '../services/api';
import { useAuth } from './Auth';

const PRESENCE_PING_INTERVAL_MS = 60000;

const PresenceHeartbeat = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      return undefined;
    }

    let cancelled = false;

    const ping = async () => {
      if (cancelled) return;
      try {
        await apiService.post('/presence/ping', {});
      } catch (error) {
        console.warn("Presence ping failed:", error);
      }
    };

    ping();
    const intervalId = setInterval(ping, PRESENCE_PING_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [user]);

  return null;
};

export default PresenceHeartbeat;
